// Values are copied VERBATIM from the backend `product_options` enum
// (eastview-os app/models/pipeline.py) — matched by string equality server-side,
// so these must not be reworded. Prefer the model schema via
// useModelFieldOptions("loanProductType") where a hook is available; this list is
// the fallback + the source for the non-hook call sites.
export const selectOptionsLoanProductType = [
  "DSCR",
  "Fix and Flip",
  // "Fix and Rent",
  "Ground Up Construction",
  "Multifamily Bridge",
  "Multifamily Value Add",
  "Stabilized Bridge",
  "HVRTL - Fix and Flip",
  "HVRTL - Bridge",
  "Other",
];
